import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[cert-func]'
})
export class CertFuncDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}